import { render, staticRenderFns } from "./DynamicDetail.vue?vue&type=template&id=51e44bf0&scoped=true"
import script from "./DynamicDetail.vue?vue&type=script&lang=js"
export * from "./DynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetail.vue?vue&type=style&index=0&id=51e44bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e44bf0",
  null
  
)

export default component.exports